<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col md="6" offset-md="3">
    <b-card class="py-4 px-5">
      <content-placeholders v-if="showContentPlaceholder">
        <content-placeholders-img style="height: 350px" />
      </content-placeholders>
      <div v-else>
        <b-form-group :label="$t('COMMON.TITLE')" label-for="normalTitle">
          <b-form-input id="normalTitle"
                        type="text"
                        :placeholder="$t('FORMS.TITLE_PLACE')"
                        v-model="form.title">
          </b-form-input>
        </b-form-group>
        <b-form-group :label="$t('FORMS.PROCESS_TYPE')" label-for="basicText" class="required">
          <b-form-select :plain="true"
                         :options="setOptions"
                         v-model="form.match_type"
                         @input="handleMatchSelect(),$v.form.match_type.$touch()"
                         :class="{'is-invalid': $v.form.match_type.$error, 'is-valid': !$v.form.match_type.$invalid}"
                         :placeholder="$t('FORMS.MATCH')"></b-form-select>
          <b-form-invalid-feedback v-if="!$v.form.match_type.required">{{ $t('TEMPLATE.REQ_TYPE') }}</b-form-invalid-feedback>
        </b-form-group>
        <b-row>
          <b-col md="6" lg="8">
            <b-form-group :label="$t('FORMS.FORCED_TEMPLATE')" label-for="basicText" v-if="canShowImgPreview">
              <b-form-select :plain="true"
                             :options="templateOptions"
                             v-model="form.forced_template_doc_id"
                             @input="handleTemplateSelect()"
                             :placeholder="$t('FORMS.TEMPLATE')"></b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="6" lg="2">
            <zoom-center-transition>
              <img :src="previewImageUrl" class="shadow preview-image" v-if="canShowImgPreview">
            </zoom-center-transition>
          </b-col>
        </b-row>
          <b-form-group v-if="isTriaging" :label="$t('FORMS.PROCESS_CATEGORIES')" label-for="ProcessCatgegories" class="required" >
            <b-form-select
              :plain="true"
              v-model="form.process_categories"
              :options="process_categories"
            ></b-form-select>
          </b-form-group>
      </div>
      <div slot="footer">
        <div class="saveButtonContainer">
        <b-button class="saveButton" type="submit" size="sm" variant="secondary" :disabled="disableButton" @click="formUpload">
           <i v-if="form.uploading" class="fa fa-spinner fa-spin mr-2" style="font-size:18px"></i><span ref="uploadText">{{ $t('COMMON.PROCESS') }}</span>
        </b-button>
        </div>
      </div>
      <b-form-group v-if="(file_length > 1) && form.title">
        <input type="checkbox" v-model="checked" id="name_checkbox">
        <label for="name_checkbox" class="ml-1" style="color:blue;">{{ $t('FORMS.USE_TITLE') }}</label>
      </b-form-group>
      <label for="dropzone">{{$t('FORMS.UPLOAD_MULTI_FORMS')}}</label>
      <b-modal centered
      id="zip-password"
      ref="zip-password-modal"
      title="Enter Password"
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      @cancel="cancel"
      @keydown.native.enter="handleZipPasswordSubmit"
      @show="resetZipModal"
      @hidden="resetZipModal"
      ok-title = "submit"
      @ok="handleZipPasswordSubmit" >
 
        <form ref="zip-form" @submit.stop.prevent="handleZipFormSubmit" autocomplete="off">
          <b-form-group
            :state="zipPasswordState"
            :label="currentFile.name"
            label-for="password-input"
            :invalid-feedback="$t('COMMON.WRONG_PASSWORD')"
          >
            <b-form-input
              id="password-input"
              type="password"
              v-model="passwordInput"
              :state="zipPasswordState"
              required
            ></b-form-input>
          </b-form-group>
        </form>
      </b-modal>
      <vueDropzone ref="formProcessDropZone"
                   id="dropzone"
                   v-if="canShowDropZone"
                   :options="dropzoneOptions"
                   @vdropzone-file-added="onAddingFile"
                   v-on:vdropzone-success="onSuccess"
                   v-on:vdropzone-sending="sendingEvent"
                   v-on:vdropzone-max-files-exceeded="onExceedingMaxFiles"
                   v-on:vdropzone-removed-file="onRemovingFile">
      </vueDropzone>
      <p class="text-danger" v-if="isDropzoneBlank">{{ $t('TEMPLATE.REQ_FILE') }}</p>
      <div v-if="isPdf" >
           <pdf
            v-for="(src,index) in pdfsources"
            :key="index"
            ref="pdfComponent"
            :src="src"
            @password="pdfPasswordEvent"
            @error="pdfError"
            @page-loaded="pdfLoaded"
            style="display:none"
        ></pdf>
      </div>
    </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.css'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'
import router from '../../router'
import { mapGetters } from 'vuex'
// import pdf from 'vue-pdf'
export default {
  name: 'upload-for-process',
  components: { vueDropzone: vue2Dropzone },
  data () {
    return {
      form: {
        title: '',
        description: '',
        file: '',
        forced_template_doc_id: null,
        match_type: null,
        accountId: '',
        process_categories: null,
        uploading: false
      },
      process_categories: [
        { value: null, text: 'Select', disabled: true },
        { value: 'fax', text: 'FAX' },
        { value: 'esf', text: 'ESF' }
      ],
      isTriaging: false,
      disableUpload: false,
      file_length: 0,
      isDropzoneBlank: false,
      isPdf: false,
      pdfpasswordInput: '',
      pdfPasswordState: null,
      pdfcurrentFileName: '',
      isPdfLoaded: false,
      isPasswordSubmit: false,
      pdfcurrentPassword: '',
      pdfsources: [],
      pdfPasswords: [],
      checked: true,
      zipPasswords: [],
      currentFile: '',
      passwordInput: '',
      zipPasswordState: null,
      option_keys: [],
      matchOptions: [{ text: 'Select', value: null, disabled: true }],
      templateOptions: [],
      dropzoneOptions: {
        url: `${process.env.API_URL}/form_docs`,
        dictDefaultMessage: this.$t('FORMS.DROP_SCANNED'),
        autoProcessQueue: false,
        thumbnailWidth: 100,
        thumbnailHeight: 150,
        parallelUploads: 5,
        maxFilesize: 30,
        maxFiles: 5,
        timeout: 300000,
        acceptedFiles: 'application/pdf, image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel,application/rtf, application/x-rtf, text/rtf, text/richtext, application/msword, application/doc, application/x-soffice, .xlsx, .xls, .zip',
        headers: { 'Authorization': '' },
        init: function () {
          this.on('addedfile', function (file) {
            file.previewElement.querySelector('.dz-details').style.backgroundColor = '#0b192d'
            var removeButton = document.createElement('div')
            removeButton.className = 'removeFormButton'
            removeButton.style.cssText = 'opacity:1;z-index:1000;position:absolute;top:5px;right:5px;color:white;'
            removeButton.innerHTML = '<i class="fa fa-trash"></i>'
            var _this = this

            removeButton.addEventListener('click', function (e) {
              e.preventDefault()
              e.stopPropagation()

              _this.removeFile(file)
            })

            file.previewElement.appendChild(removeButton)
          })
        }
      },
      showContentPlaceholder: false,
      canShowImgPreview: false,
      previewImageUrl: '',
      files: 0
    }
  },
  computed: {
    ...mapGetters(['idToken', 'accountId', 'isAdminRole']),
    canShowDropZone () {
      this.dropzoneOptions.headers['Authorization'] = `Bearer ${this.idToken}`
      return (this.idToken !== '')
    },
    disableButton () {
      return !((this.$v.$invalid && !this.$v.$dirty) || !this.$v.$invalid) || this.disableUpload
    },
    setOptions () {
      this.matchOptions = [{ text: this.$t('UPLOAD_DROPDOWN.SELECT'), value: null, disabled: true }]
      this.matchOptions = this.matchOptions.concat(this.option_keys.map(processType => { return { text: this.$t('UPLOAD_DROPDOWN.' + processType.key), value: processType.value } }))
      return this.matchOptions
    },
    pdfinvalidFeedback () {
      if (this.pdfpasswordInput.length > 4) {
        return ''
      } else {
        return this.$t('COMMON.WRONG_PASSWORD')
      }
    }
  },
  methods: {
    onSuccess (file, message, xhr) {
      const routerQuery = this.prepareRouteQuery()
      router.push({path: '/process/processed', query: routerQuery})
    },
    prepareRouteQuery () {
      const processCat = this.form.process_categories
      const query = { status: 'processing' }
      if (processCat) {
        query.category = processCat
      }
      return query
    },
    onAddingFile (file) {
      this.isDropzoneBlank = !this.$refs.formProcessDropZone.dropzone.files.length
      if (['application/zip', 'application/octet-stream', 'application/x-zip-compressed', 'multipart/x-zip'].indexOf(file.type) >= 0) {
        this.checkZipPassword(file)
      }
    },
    async checkZipPassword (file) {
      this.zipPasswords[file.upload.uuid] = ''
      let apiData = new window.FormData()
      apiData.append('password', '')
      apiData.append('file', file)
      this.disableUpload = true
      let invalid = await this.postZip(apiData, 0)
      if (!invalid) {
        this.currentFile = file
        this.$refs['zip-password-modal'].show()
      } else {
        this.disableUpload = false
      }
    },
    postZip (apiData, flag) {
      return new Promise((resolve, reject) => {
        Vue.axios.post('/form_docs/check_zip_password', apiData, { headers: { Authorization: `Bearer ${this.idToken}` } })
          .then(response => {
            if (response.data.status === 'Wrong Password' && flag) {
              Vue.toasted.show(this.$t('COMMON.WRONG_PASSWORD'), { icon: 'chain-broken', type: 'error' })
              resolve(false)
            } else if (response.data.status === 'Correct Password' && flag) {
              this.zipPasswords[this.currentFile.upload.uuid] = this.passwordInput
              this.disableUpload = false
              resolve(true)
            } else if (response.data.status === 'Wrong Password' && flag === 0) {
              resolve(false)
            } else {
              resolve(true)
            }
            this.zipPasswordState = null
            this.passwordInput = ''
          }, () => {
            this.$refs.formProcessDropZone.dropzone.removeFile(this.currentFile)
            this.zipPasswordState = null
            this.passwordInput = ''
            Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
            this.disableUpload = false
            resolve(true)
          })
      })
    },
    async checkZipFormValidity () {
      let valid = this.$refs['zip-form'].checkValidity()
      this.zipPasswordState = valid
      if (!valid) {
        return false
      } else {
        let apiData = new window.FormData()
        apiData.append('password', this.passwordInput)
        apiData.append('file', this.currentFile)
        let pwdValid = await this.postZip(apiData, 1)
        return pwdValid
      }
    },
    async handleZipFormSubmit () {
      if (!await this.checkZipFormValidity()) {
        return
      }
      this.$nextTick(() => {
        this.$refs['zip-password-modal'].hide()
      })
    },
    async invalidFeedback () {
      if (await this.checkZipFormValidity()) {
        return ''
      } else {
        return this.$t('COMMON.WRONG_PASSWORD')
      }
    },
    handleZipPasswordSubmit (bvModalEvt) {
      bvModalEvt.preventDefault()
      this.handleZipFormSubmit()
    },
    handleEnter () {
      this.handleZipFormSubmit()
    },
    cancel () {
      this.$refs.formProcessDropZone.dropzone.removeFile(this.currentFile)
      this.zipPasswordState = null
      this.passwordInput = ''
      this.disableUpload = false
    },
    resetZipModal () {
      this.zipPasswordState = null
    },
    handleMatchSelect: function () {
      if (this.form.match_type === -4 && this.templateOptions.length > 0) {
        this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + this.templateOptions[0].image_url
        this.form.forced_template_doc_id = this.templateOptions[0].value
        this.canShowImgPreview = true
      } else {
        this.form.forced_template_doc_id = this.form.match_type
        this.canShowImgPreview = false
      }
      this.isTriaging = this.form.forced_template_doc_id === -13
    },
    handleTemplateSelect: function () {
      var thisObj = this
      var selectedOpt = _.find(this.templateOptions, function (topt) { return topt.value === thisObj.form.forced_template_doc_id })
      this.previewImageUrl = this.axios.defaults.baseURL.replace('/api', '') + selectedOpt.image_url
    },

    formUpload: async function () {
      var _this = this
      if (this.$refs.formProcessDropZone.dropzone.files.length && (this.form.match_type || this.form.match_type === 0)) {
        var myDropzone = this.$refs.formProcessDropZone.dropzone
        this.uploadStart()
        myDropzone.processQueue()
        myDropzone.on('complete', function (file) {
          if (this.getUploadingFiles().length === 0) {
            _this.uploadEnd()
          }
          myDropzone.removeFile(file)
        })
      } else if (this.$v.$invalid) {
        this.$v.form.$touch()
      } else {
        this.isDropzoneBlank = true
      }
    },
    fetchProcessTypes: function () {
      Vue.axios.get('/settings/process_types/account_process_types', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(res => {
          this.option_keys = res.data.account_process_types.map(processType => { return { key: processType.key, value: processType.value } })
        })
        .catch(error => {
          if (error.status === 401) {
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    fetchTemplateOptions: function () {
      Vue.axios.get('/template_docs/list_options', { headers: { Authorization: `Bearer ${this.idToken}` } })
        .then(response => {
          this.templateOptions = response.data.template_docs
        }, error => {
          if (error.status === 401) {
            Vue.toasted.show(this.$t('COMMON.MSG_EXPIRED'), { icon: 'chain-broken', type: 'error' })
            console.log(this.$t('COMMON.MSG_EXPIRED'))
          } else if (error.status === 500) {
            Vue.toasted.show(this.$t('COMMON.MSG_PROCESS_FAIL'), { icon: 'chain-broken', type: 'error' })
          }
        })
    },
    sendingEvent (file, xhr, formData) {
      if (this.form.title && this.checked) {
        formData.append('title', this.form.title)
      } else {
        formData.append('title', file.name)
      }
      formData.append('account_id', this.accountId)
      // formData.append('key', this.pdfPasswords[file.name])
      formData.append('forced_template_doc_id', this.form.forced_template_doc_id)
      formData.append('process_categories', this.form.process_categories)
      formData.append('password', this.zipPasswords[file.upload.uuid])
    },
    uploadStart () {
      this.form.uploading = true
      this.showContentPlaceholder = true
      this.$refs.uploadText.innerText = this.$t('FORMS.UPLOAD_PROCESS')
    },
    uploadEnd () {
      this.showContentPlaceholder = false
      this.$refs.uploadText.innerText = this.$t('COMMON.UPLOAD')
    },
    onExceedingMaxFiles () {
      Vue.toasted.show(this.$t('COMMON.MSG_FILE_LIMIT'), { icon: 'chain-broken', type: 'error' })
    },
    onRemovingFile () {
      this.file_length = this.$refs.formProcessDropZone.dropzone.files.length
      this.isDropzoneBlank = !this.$refs.formProcessDropZone.dropzone.files.length
      var myDropzone = this.$refs.formProcessDropZone.dropzone
      if (myDropzone.getRejectedFiles().length > 0 && myDropzone.getAcceptedFiles().length < myDropzone.options.maxFiles) {
        myDropzone.getRejectedFiles()[0]['status'] = 'queued'
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-error')
        myDropzone.getRejectedFiles()[0]['previewTemplate']['classList'].remove('dz-complete')
        myDropzone.getRejectedFiles()[0]['accepted'] = true
      }
    }
  },
  created () {
    console.log('created')
    this.fetchProcessTypes()
    this.fetchTemplateOptions()
  },
  validations: {
    form: {
      match_type: {
        required
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .preview-image {
    padding: 3px;
    border: 2px solid #ccc;
  }

  .dropzone {
    background-color: #eee;
    border: 1px solid #aaa;
    border-radius: .2rem;
  }

  #fileInput {
  	width: 0.1px;
  	height: 0.1px;
  	opacity: 0;
  	overflow: hidden;
  	position: absolute;
  	z-index: -1;
  }

  #fileInput + label {
    display: inline-block;
    color: white;
    background-color: #0e2547;
    padding: .5rem 3rem;
    cursor: pointer;
    outline: 1px dotted #000;
    outline: -webkit-focus-ring-color auto 5px;
  }

  .saveButtonContainer {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .saveButton {
    border-radius: 1rem;
    font-size: 1rem;
    padding: 0.5rem 5rem;
  }

  .card-footer {
    background-color: white;
  }

</style>



// WEBPACK FOOTER //
// src/views/process/Upload.vue